import type { Recipe } from '@/types';
import { time } from '@/time';

const recipe: Recipe = {
  title: 'Korean Fried Chicken',
  source: 'https://www.seriouseats.com/korean-fried-chicken-recipe',
  totalTime: time(1, 25),
  servings: 4,
  tags: { type: 'main' },
  ingredients: [
    { name: 'kosher salt', quantity: '2', unit: 'tsp' },
    { name: 'corn starch', quantity: '3/4', unit: 'cup' },
    { name: 'baking powder', quantity: '1', unit: 'tsp' },
    { name: 'chicken wings', quantity: '2', unit: 'lb' },
    { name: 'peanut oil', quantity: '2', unit: 'quart',
      fixed: true,
    },
    { name: 'all-purpose flour', quantity: '1/2', unit: 'cup' },
    { name: 'cold water', quantity: '1/2', unit: 'cup' },
    { name: 'vodka', quantity: '1/2', unit: 'cup' },
    { name: 'gochujang sauce', quantity: '1', unit: 'recipe', customUnit: true,
      recipe: 'gochujang-sauce',
    },
  ],
  directions: [
    {
      title: 'Dredge & rest wings',
      bullets: [
        "In large bowl, whisk {kosher salt:1 tsp}, {corn starch:1/4 cup} & {baking powder:1/2 tsp} until homogenous",
        "Coat every surface of {chicken wings} with dry mixture",
        "Shake off excess coating & transfer to wire rack",
        "Refrigerate uncovered at 30 min to 12 hr",
      ],
    },
    {
      title: 'Make batter',
      bullets: [
        "In large bowl, whisk {corn starch:1/2 cup}, {baking powder:1/2 tsp}, {all-purpose flour} & {kosher salt:1 tsp} until homogenous",
        "Add {cold water} & {vodka}",
        "Whisk until smooth - batter should be thin paint consistency & fall off whisk in thin ribbons that disappear as they hit surface of batter (add up to {=2 tbsp} more water if too thick)",
      ],
    },
    {
      title: 'Fry wings',
      bullets: [
        "In deep fryer, preheat {peanut oil} to {!350F}",
        "Add wings to batter in {=fixed 1 lb} batches",
        "One piece at a time, lift wing, let excess batter drip off & transfer into hot oil",
        "Fry & rotate until evenly golden brown & crisp (~8 min per batch)",
        "Transfer to paper towel-lined plate",
      ],
    },
    {
      title: 'Serve',
      bullets: [
        "Serve plain or with {gochujang sauce}",
      ],
    },
  ],
};

export default recipe;
